import reducer from 'state/mrDistribution/ui/reducer';
import actions from 'state/mrDistribution/ui/actionCreators';
import selectors from 'state/mrDistribution/ui/selectors';

export { actions, selectors };

export default reducer;
